module.exports = __webpack_public_path__ + "img/mom-child-airport.277dc038.png";